import { lazy, Suspense } from "react";
import { PATH_ONBOARDING } from "./paths";
import AuthGuard from "@/guards/AuthGuard";
import { Outlet } from "react-router-dom";

const OnboardingContainer = lazy(() => import("@/pages/onboarding/onboarding.container"));

const onboardingRoutes = [
  {
    path: PATH_ONBOARDING,
    element: (
      <AuthGuard>
        <Suspense>
          <Outlet />
        </Suspense>
      </AuthGuard>
    ),
    children: [
      {
        element: <OnboardingContainer />,
        index: true,
      },
    ],
  },
];

export default onboardingRoutes;
